import React from 'react';
import { Link } from 'react-router-dom';
import { Tag, Space } from 'antd';

const ListScreenKeys = ({ documentData }) => {
  const colorArray = ['blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple', 'blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple'];
  const record = documentData;
  const pos = record?.reference_purchase_orders
    ?.filter((po) => po?.status !== 'CANCELLED')
    ?.map((item) => (
      <div key={item?.po_id}>
        <Link to={`/approval?type=po&id=${item?.po_id}`} target="_blank" rel="noopener noreferrer">
          {item?.po_number}
        </Link>
      </div>
    ));
  const sts = record?.reference_stock_transfers
    ?.filter((st) => st?.status !== 'VOID')
    ?.map((item) => (
      <div key={item?.stock_transfer_id}>
        <Link to={`/approval?type=po&id=${item?.stock_transfer_id}`} target="_blank" rel="noopener noreferrer">
          {item?.stock_transfer_number}
        </Link>
      </div>
    ));
  const label = (
    <div className="table-labels__list min-width-70">
      <Space size={[0, 8]} wrap>
        {record?.tags?.map((tag, index) => (
          <Tag
            key={`${tag}-${index}`}
            color={colorArray?.[index % colorArray.length] || 'default'}
          >
            {tag}
          </Tag>
        ))}
      </Space>
    </div>
  );

  return [
    {
      label: 'Items',
      value: record.lines_count || '-',
    },
    {
      label: 'Requestor',
      value: `${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')}`,
    },
    {
      label: 'Purchase Orders',
      value: pos || '-',
    },
    {
      label: 'Stock Transfer',
      value: sts || '-',
    },
    {
      label: 'Labels',
      value: label || '-',
    },
  ];
};

export {
  ListScreenKeys,
};
